<template>
  <div style="max-height: 80vh" class="flex flex-col overflow-hidden">
    <div style="height: 85%" class="order flex-1 overflow-auto hide-scroll">
      <div v-if="!!receiptNumber" class="receipt-number-cont">
        شماره فیش:
        <p class="receipt-number">{{ receiptNumber }}</p>
      </div>
      <div v-if="order.user" class="user">
        <div class="info">
          <img
            class="avatar"
            :src="order.user.avatar.url || placeholder"
            :alt="order.user.name"
          />
          <div class="block">
            <div class="name">{{ order.user.name }}</div>
            <div class="phone">{{ order.user.phone }}</div>
          </div>
        </div>
        <div class="action-buttons-cont">
          <div class="flex" style="flex-direction: column">
            <!--<vs-button @click="call()" size="small">تماس با کاربر</vs-button>-->
            <vs-button
              class="py-2 text-sm md:text-base"
              @click="providerPrint()"
            >
              پرینت مجموعه
            </vs-button>
            <vs-button
              class="py-2 text-sm md:text-base mt-2"
              @click="customerPrint()"
            >
              پرینت مشتری
            </vs-button>
          </div>
        </div>
      </div>
      <ul class="grid grid-cols-2 pt-6 row-gap-1 sm:row-gap-2">
        <li class="flex flex-col sm:flex-row gap-1 pb-1 sm:items-center">
          <span
            style="
              max-width: 95px;
              width: 100%;
              color: #00000099;
              font-size: 13px;
            "
          >
            شماره سفارش :
          </span>

          <span style="font-size: 14px" class="font-bold text-black">
            {{ order.serial }}
          </span>
        </li>
        <li class="flex flex-col sm:flex-row gap-1 pb-1 sm:items-center">
          <span
            style="
              max-width: 95px;
              width: 100%;
              color: #00000099;
              font-size: 13px;
            "
          >
            وضعیت پرداخت :
          </span>
          <!-- 1. Payment Required -->
          <span class="item-text" v-if="order.status === 'payment_required'">
            در انتظار پرداخت
          </span>

          <!-- 2. Offline Payment -->
          <template v-else-if="order.paymentType === 'offline'">
            <!-- Has Payment object (Settled) -->
            <span class="font-bold text-success" v-if="order.payment">
              تسویه شده
            </span>
            <!-- No Payment object (Not Settled) -->
            <div class="flex items-center gap-1" v-else>
              <span class="font-bold text-black">تسویه نشده </span>
              <payment-settlement-button
                v-if="order.status === 'approved'"
                :order-id="order.id"
                :shop-id="currentProvider.id"
                @success="$emit('refreshList')"
                className="ml-2"
                :sx="{ padding: '4px 8px', minWidth: 'unset' }"
              />
            </div>
          </template>

          <!-- 3. Online Payment -->
          <span
            class="item-text text-success"
            v-else-if="order.paymentType === 'online'"
          >
            تسویه شده
          </span>
        </li>
        <li class="flex flex-col sm:flex-row gap-1 pb-1 sm:items-center">
          <span
            style="
              max-width: 95px;
              width: 100%;
              color: #00000099;
              font-size: 13px;
            "
          >
            نوع سفارش :
          </span>

          <span style="font-size: 14px" class="font-bold text-black">
            {{ getOrderType() }}
          </span>
        </li>
        <li class="flex flex-col sm:flex-row gap-1 pb-1 sm:items-center">
          <span
            style="
              max-width: 95px;
              width: 100%;
              color: #00000099;
              font-size: 13px;
            "
          >
            تاریخ سفارش :
          </span>

          <span style="font-size: 14px" class="font-bold text-black">
            {{ order.created_at }}
          </span>
        </li>

        <li
          v-if="
            (order.userDetails && order.userDetails.destination) || order.table
          "
          class="flex flex-col sm:flex-row gap-1 pb-1 items-censm:ter"
        >
          <span
            style="
              max-width: 95px;
              width: 100%;
              color: #00000099;
              font-size: 13px;
            "
          >
            {{ order.type === "indoor" ? "شماره میز :" : "آدرس :" }}
          </span>

          <span style="font-size: 14px" class="font-bold text-black">
            {{ getDestination() }}
          </span>
        </li>

        <li
          v-if="order.userDetails && order.userDetails.description"
          class="flex flex-col sm:flex-row gap-1 pb-1 items-censm:ter"
        >
          <span
            style="
              max-width: 95px;
              width: 100%;
              color: #00000099;
              font-size: 13px;
            "
          >
            توضیحات :
          </span>

          <span style="font-size: 14px" class="font-bold text-black">
            {{ order.userDetails.description }}
          </span>
        </li>

        <li
          v-if="order.payment && order.payment.gateway_reference"
          class="flex flex-col sm:flex-row gap-1 pb-1 items-censm:ter"
        >
          <span
            style="
              max-width: 95px;
              width: 100%;
              color: #00000099;
              font-size: 13px;
            "
          >
            شماره پیگیری :
          </span>

          <span style="font-size: 14px" class="font-bold text-black">
            {{ order.payment.gateway_reference }}
          </span>
        </li>
      </ul>

      <h2 class="orders-list-title">لیست سفارشات</h2>
      <ul
        ref="itemsList"
        class="orders-list mt-0 mb-1"
        :class="{ 'hide-scroll': !showAllItems }"
        :style="
          showAllItems
            ? ''
            : `max-height: 200px; overflow-y: auto; min-height: 70px;`
        "
      >
        <li class="" v-for="item in order.items" :key="item.id">
          <span class="product-title">{{ item.quantity }} &times;</span>
          <span class="product-title">
            {{ item.title }}
            <span class="text-danger" v-if="item.discount && item.discount > 0"
              >(%{{ item.discount }})</span
            >
          </span>
          <span class="dashed-line"></span>
          <span class="product-price"
            >{{
              (calcProductPrice(item) * item.quantity).toString().numberFormat()
            }}
            ریال
          </span>
        </li>
      </ul>

      <div v-if="showToggleButton" class="w-full text-center mt-2">
        <div
          @click="showAllItems = !showAllItems"
          class="cursor-pointer bg-black mx-auto text-white flex items-center justify-center py-2 px-4 rounded-full transition"
          style="max-width: fit-content"
        >
          <span class="text-sm ml-1">
            {{ showAllItems ? "بستن" : "مشاهده بیشتر" }}
          </span>
          <feather-icon
            :icon="showAllItems ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            svgClasses="w-4 h-4"
          />
        </div>
      </div>
      <vs-divider class="my-4"></vs-divider>
      <ul class="orders-list mb-4">
        <li class="flex items-center justify-between">
          <span class="order-title font-bold text-xl">تعداد</span>

          <span class="price font-bold text-xl">{{ productsCount }} عدد</span>
        </li>
        <li
          class="flex items-center justify-between"
          v-if="+order.discount > 0"
        >
          <span class="order-title text-danger">
            تخفیف
            <span>(%{{ discountDistinct }})</span>
          </span>

          <span class="price text-danger"
            >{{ order.discount.toString().numberFormat() }} ریال</span
          >
        </li>
        <li
          class="flex items-center justify-between"
          v-if="+order.delivery_fee > 0"
        >
          <span class="order-title">مبلغ پیک</span>

          <span class="price"
            >{{ order.delivery_fee.toString().numberFormat() }} ریال</span
          >
        </li>
        <li class="flex items-center justify-between" v-if="+order.vat > 0">
          <span class="order-title">مالیات ({{ TAX_LABEL }})</span>

          <span class="price"
            >{{ order.vat.toString().numberFormat() }} ریال</span
          >
        </li>
        <li class="flex items-center justify-between">
          <span class="order-title font-bold text-xl">مبلغ پرداختی</span>

          <span class="price font-bold text-xl"
            >{{ orderPrice.toString().numberFormat() }} ریال</span
          >
        </li>
      </ul>
    </div>
    <div>
      <div class="footer">
        <div class="order-status text-success" v-if="status === 'approved'">
          <feather-icon icon="CheckCircleIcon"></feather-icon>
          این سفارش تایید شده است.
        </div>
        <div
          v-if="
            status === 'approved' &&
            order.providerDetails &&
            order.providerDetails.update
          "
          class="timeleft-to-send mt-3"
        >
          <span class="title">{{ order.providerDetails.update }}</span>
        </div>
        <div class="row" style="margin-bottom: 10px">
          <div
            v-if="
              status === 'approved' &&
              order.providerDetails &&
              order.providerDetails.processingTime
            "
            class="timeleft-to-send"
          >
            <span style="margin-left: 5px" class="title">
              زمان باقی مانده تا تحویل سفارش: {{}}
            </span>
            <counter
              :month="false"
              :datetime="order.providerDetails.processingTime"
            ></counter>
          </div>
          <div v-if="order.has_changed">
            <div class="hasChanged">ویرایش شده</div>
          </div>
        </div>
        <div class="order-status text-danger" v-if="status === 'denied'">
          <feather-icon icon="XCircleIcon"></feather-icon>
          این سفارش لغو شده است.
        </div>
        <allow-deny
          @change="status = $event"
          :orderStatus="status"
          :order="order"
          :paymentType="order.paymentType"
          @refreshList="$emit('refreshList')"
        >
        </allow-deny>
      </div>
      <web-print-receipt
        ref="webPrintReceiptRef"
        :order="order"
        :index="index"
        @order-updated="onOrderUpdated"
      />
      <div v-if="order.reviewer" class="reviewer">
        متصدی ثبت کننده:
        <span class="user-name">{{ order.reviewer.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import { mapGetters } from "vuex";
  import user_placeholder from "../../assets/images/user-placeholder.png";
  import { TAX_FEE, TAX_LABEL } from "../../helpers/Constants";
  import { convertToEnglishDigit } from "../../helpers/Functions";
  import PaymentSettlementButton from "../PaymentSettlementButton.vue";
  import WebPrintReceipt from "../print/WebPrintReceipt.vue";
  import AllowDeny from "./AllowDeny";

  export default {
    name: "Order",
    components: {
      AllowDeny,
      WebPrintReceipt,
      PaymentSettlementButton,
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
      receiptNumber() {
        return this.order?.receipt_number || null;
      },
      visibleItems() {
        if (this.showAllItems) {
          return this.order.items;
        }
        return this.order.items.slice(0, 4);
      },
      productsCount() {
        let count = 0;
        this.order.items.forEach((item) => {
          count += item.quantity;
        });
        return count;
      },
      orderPrice() {
        // این Price مبلغ اصلی فاکتور است و discount مبلغ تخفیفی است که به ریال محاسبه شده است.
        // return this.order.price - this.order.discount;
        return this.order.price;
      },
      discountDistinct() {
        if (!this.order.discount) return 0;

        let price = 0;
        this.order.items.forEach((item) => {
          const discount = item.discount || 0;
          const finalPrice = item.price - item.price * (discount / 100);
          price += finalPrice * item.quantity;
        });

        return Math.round((this.order.discount * 100) / price);
      },
    },

    data() {
      return {
        status: this.order.status,
        placeholder: user_placeholder,
        TAX_LABEL,
        showAllItems: false,
        showToggleButton: false,
      };
    },
    props: {
      order: {
        required: true,
        type: Object,
      },
      index: {
        requird: false,
        type: Number,
      },
    },
    watch: {
      order: {
        deep: true,
        handler() {
          this.$nextTick(this.checkOverflow);
        },
      },
      showAllItems() {
        this.$nextTick(this.checkOverflow);
      },
    },
    mounted() {
      this.$nextTick(this.checkOverflow);
    },
    methods: {
      onOrderUpdated(payload) {
        this.$emit("refreshList", payload);
      },
      checkOverflow() {
        const el = this.$refs.itemsList;
        if (!el) return;

        if (!this.showAllItems) {
          this.showToggleButton = el.scrollHeight > el.clientHeight;
        }
      },
      getDestination() {
        if (this.order.type === "indoor") {
          return this.order.table?.title || this.order.userDetails.destination;
        }

        return convertToEnglishDigit(this.order.userDetails.destination);
      },
      getOrderType() {
        if (this.order.type === "indoor") {
          return "داخل سالن";
        } else if (this.order.type === "outdoor") {
          return "ارسالی";
        } else {
          return "تحویل در محل";
        }
      },
      getProcessingTime() {
        if (this.order.providerDetails) {
          const time = moment(this.order.providerDetails.processingTime).format(
            "HH:mm"
          );
          return time;
        }

        return null;
      },
      call() {
        window.location.href = "tel:" + this.order.user.phone;
      },
      calcProductPrice(product, withTax = false) {
        let tax = 0;

        if (withTax && this.order.vat > 0) {
          tax = product.tax || TAX_FEE;
        }

        const discount = product.discount || 0; // Discount of item
        const priceWithDiscount =
          product.price - product.price * (discount / 100); // Calculated price with discount
        const finalPrice = priceWithDiscount + priceWithDiscount * tax; // Calculated price with tax

        return finalPrice;
      },
      calcProductsPriceSum(items, withTax = false) {
        if (items) {
          let price = 0;
          items.forEach((element) => {
            price += this.calcProductPrice(element, withTax) * element.quantity;
          });
          return price;
        }

        return 0;
      },
      providerPrint() {
        this.$refs["webPrintReceiptRef"]
          .providerPrint()
          .then((receiptNumber) => (this.receiptNumber = receiptNumber));
      },
      customerPrint() {
        this.$refs["webPrintReceiptRef"]
          .customerPrint()
          .then((receiptNumber) => (this.receiptNumber = receiptNumber));
      },
    },
  };
</script>

<style scoped lang="scss">
  .hide-scroll {
    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .order {
    height: 80%;
    background-color: #ffffff;
    font-size: 13px;
    border-radius: 15px;
    transition: 0.3s all;
    display: flex;
    flex-direction: column;

    .action-buttons-cont {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .receipt-number-cont {
      display: flex;
      align-items: center;
      margin-bottom: 5px;

      .receipt-number {
        font-weight: bold;
        color: #232323;
        font-size: 1.5rem;
        margin-left: 3px;
      }
    }

    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .hasChanged {
      font-size: 0.9rem;
      background-color: #0f437b;
      color: #fff;
      border-radius: 5px;
      padding: 0.5rem 1rem;
      text-align: center;
    }

    .index {
      font-size: 18px;
      color: #000000;
      font-weight: 700;
      margin-bottom: 10px;
      display: block;
    }

    .user {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .info {
        display: flex;
        align-items: center;

        .avatar {
          display: block;
          width: 60px;
          height: 60px;
          object-fit: cover;
          object-position: center;
          border-radius: 50%;
          padding: 1px;
          margin-right: 10px;
        }

        .name {
          font-weight: 700;
          color: #000000;
          font-size: 14px;
        }
        .phone {
          font-weight: 400;
          color: #000000;
          font-size: 14px;
        }
      }
    }

    .info-list {
      margin-top: 10px;

      & > li:not(:first-child) {
        margin-top: 5px;
      }

      .payment-status-container {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .offline-payment {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .item-text {
        font-weight: 700;
        color: #000000;
      }
    }

    .orders-list-title {
      font-size: 16px;
      font-weight: 700;
      margin-top: 24px;
      text-align: center;
      color: #141e47;
    }

    .orders-list {
    }

    .orders-list > li {
      margin-top: 10px;
      display: flex;
      align-items: center;
      font-size: 15px;

      .product-price,
      .product-title {
        font-weight: 400;
        color: #000000;
        margin-left: 5px;
        font-size: 14px;
      }

      .price,
      .order-title {
        font-weight: 400;
        color: #000000;
        margin-left: 5px;
        font-size: 14px;
      }

      .dashed-line {
        flex: 1;
        height: 1px;
        border-bottom: 1px dashed #000000;
        margin: 0 5px;
      }

      .line {
        flex: 1;
        height: 1px;
        background-color: #d8d8d8;
        margin: 0 5px;
      }
    }
  }

  .order-status {
    display: flex;
    align-items: center;

    font-weight: 700;
    color: #000000;

    .feather-icon {
      color: inherit;
      margin-right: 5px;
    }
  }

  .timeleft-to-send {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .title {
      font-weight: 600;
      color: #000000;
    }
  }

  .reviewer {
    font-size: 14px;
    margin-top: 10px;
    color: #000000;

    .user-name {
      font-weight: 900;
    }
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .footer {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
</style>
